export interface TimezoneItem {
  timezone: string;
  description: string;
  offsetPart: string;
}

export function getAllTimezoneOptions(): TimezoneItem[] {
  const timezones = Intl.supportedValuesOf('timeZone');

  return timezones.map(getTimezoneOption);
}

export function getDefaultTimezone(isEnGb: boolean): string {
  return isEnGb ? 'Europe/London' : 'Europe/Oslo';
}

export function getTimezoneOption(timeZone: string): TimezoneItem {
  // Create a Date object representing the current time
  const date = new Date();

  // Use Intl.DateTimeFormat to format the date in the specified timeZone
  let formatter;

  try {
    formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone,
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'shortOffset', // Include timeZoneName in the format
    });
  } catch (e) {
    // Fallback for older browsers like Safari 14.1
    formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone,
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short',
    });
  }

  // Get the formatted date in the given locale and timeZone
  const formattedDate = formatter.format(date);

  const offsetPart = formattedDate.split(' ')[1];

  return {
    timezone: timeZone,
    description: `(${offsetPart}) ${timeZone}`,
    offsetPart: offsetPart,
  } as TimezoneItem;
}

export function getTimezoneOffsetPart(timezone: string): string {
  return ` (${getTimezoneOption(timezone).offsetPart})`;
}
